// @link https://stackoverflow.com/a/68146409/19588
const RegExpUnicodeModified = /\p{RI}\p{RI}|\p{Emoji}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?(\u{200D}\p{Emoji}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?)+|\p{EPres}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?|\p{Emoji}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})/gu

// @link https://stackoverflow.com/a/68663807/19588
export function extractEmoji(text) {
    if (!text) return [];
    let matches = text.match(RegExpUnicodeModified);
    if (!matches || matches === null) return [];
    return matches;
}
